import { useForm, Controller } from 'react-hook-form';
import FormInput from '../../../../components/FormInput';
import Button from '../../../../components/Button';
import { submitBtnTxt } from '../../../../helpers/functions';
import { requiredFieldFunction } from '../../../../helpers/yupValidations';
import { object } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { getGoogleDriveConfigure } from '../../actions';
import { useEffect } from 'react';
import PasswordInput from '../../../../components/PasswordInput';
import { useTranslation } from 'react-i18next';

const schema = object().shape({
  googleClientId: requiredFieldFunction('Client Id'),
  googleClientSecret: requiredFieldFunction('Secret Client'),
});
export default function DriveConfig({ rowData }) {
  const { t } = useTranslation();
  const { googleClientId = '', googleClientSecret = '' } = rowData || {};
  const isReConfig = Boolean(googleClientId) && Boolean(googleClientSecret);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: { googleClientId: '', googleClientSecret: '' },
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: getGoogleDriveConfigure,
    onSuccess: ({ data }) => {
      console.log(data?.data?.url);
      window.open(data?.data?.url, '_self');
    },
  });
  const onSubmit = (_) => mutate(_);

  useEffect(() => {
    if (isReConfig) {
      reset({ googleClientId, googleClientSecret });
    }
  }, [isReConfig]);
  return (
    <div className="w--full">
      <form
        className="w--full d--flex flex--column gap--md"
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="off"
      >
        <div className=" d--flex flex--column gap--md ">
          <div className="w--full">
            <Controller
              name="googleClientId"
              control={control}
              render={({ field }) => (
                <FormInput
                  {...field}
                  label="Client Id"
                  error={errors?.googleClientId?.message}
                />
              )}
            />
          </div>

          <div className="w--full">
            <Controller
              name="googleClientSecret"
              control={control}
              render={({ field }) => (
                <PasswordInput
                  {...field}
                  label="Client Secret"
                  error={errors?.googleClientSecret?.message}
                />
              )}
            />
          </div>

          <div>
            <span className="font--600 ">Redirect URI</span>:{' '}
            {process.env.REACT_APP_BASE_API_URL}/
            configuration/storage?type=google_drive
          </div>
          <div>
            <span className="font--600"> {t('translation:button.Info')}</span>:
            {t('translation:message.RedirectURl')}
          </div>
        </div>
        <div className="w--full d--flex align-items--center justify-content--center m-t--md">
          <Button
            btnClasses="btn  w-max--150 text--black"
            variant="primary"
            color="black"
            type="submit"
            disabled={isLoading}
          >
            {submitBtnTxt(
              isLoading,
              isReConfig
                ? t('translation:button.Re-Configure')
                : t('translation:button.Configure'),
            )}
          </Button>
        </div>
      </form>
    </div>
  );
}
